import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

// auth0-spa-js only resolves undefined when an interactiveErrorHandler is
// configured, which we don't use, so a missing token is treated as an error
export default function useAccessToken(): () => Promise<string> {
  const { getAccessTokenSilently } = useAuth0();

  return useCallback(async () => {
    const token = await getAccessTokenSilently();

    if (!token) {
      throw new Error('Auth0 returned no access token');
    }

    return token;
  }, [getAccessTokenSilently]);
}
